var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-check",class:`form-check--${_vm.type}`},[_vm._t("default",null,{"id":_vm.id,"inputClass":"form-check__input","type":_vm.type}),_c('label',{staticClass:"form-check__label",attrs:{"for":_vm.id}},[_vm._t("label")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }